import React from "react";
import { Link } from "react-router-dom";
import FeatureCards from "../components/FeatureCards";
import LatestUploads from "../components/LatestUploads";
import InfoGrid from "../components/InfoGrid";
import AdSlot from "../components/AdSlot";

const Home = () => {
  return (
    <div>
      <AdSlot slot="home-top" />
      <LatestUploads />
      <FeatureCards />
      <AdSlot slot="home-mid" />
      <InfoGrid />
      <AdSlot slot="home-bottom" />

      {/* Legal — very bottom of the home page */}
      <section className="mx-auto max-w-4xl px-4 pb-12 md:px-8">
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="mx-auto max-w-3xl text-xs leading-relaxed text-[#9a9a9a]">
            The information on Incarcerated.com.au is provided for general informational and
            personal-interest purposes only and reflects personal experiences and opinions. It is
            not legal, medical or professional advice. Please read our full Disclaimer and Privacy
            Policy below.
          </p>
          <div className="mt-4 flex items-center justify-center gap-6">
            <Link
              to="/privacy-policy"
              className="font-display text-sm uppercase tracking-wide text-[#e0a82e] underline-offset-4 transition-colors hover:text-[#f2b93f] hover:underline"
            >
              Privacy Policy
            </Link>
            <span className="text-[#555]">|</span>
            <Link
              to="/disclaimer"
              className="font-display text-sm uppercase tracking-wide text-[#e0a82e] underline-offset-4 transition-colors hover:text-[#f2b93f] hover:underline"
            >
              Disclaimer
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
